import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";

@Component({
  selector: 'app-chemistry-lab',
  templateUrl: './chemistry-lab.component.html',
  styleUrls: ['./chemistry-lab.component.scss']
})
export class ChemistryLabComponent implements OnInit {    
  selectedLanguage = "";
  chemistry_lab: any[] = [];

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Chemistry API Response");

      if (response?.data) {
        // Filter for Library category
        this.chemistry_lab  = response.data.filter(
          (x: any) => x.ContentCategoryName === "Chemistry Lab"
        );
        console.log(this.chemistry_lab , "Filtered chemistry Data");
      }
    });
  }
}
